import React from 'react';
import styled from 'styled-components';

import Section from '../global/section';
import Top from '../top';
import mdToHtml from '../../util/mdToHtml';

const StyledContent = styled.div`
	h2 {
		margin-bottom: 1.5rem;
	}
	.top {
		text-transform: uppercase;
	}
	.flex {
		display: flex;
		margin-top: 2rem;
		padding-top: 3rem;
		border-top: 1px solid ${(p) => p.theme.color.lightGrey};
		.left {
			width: 60%;
			padding-right: 3rem;
		}
		.right {
			width: 40%;
			padding-top: 2rem;
			img {
				max-width: 350px;
				width: 100%;
				border-radius: 50%;
			}
		}
		@media all and (max-width: 768px) {
			flex-wrap: wrap;
			.left,
			.right {
				width: 100%;
				padding-right: 0;
			}
		}
	}
`;

export default ({ data, title }) => {
	const { content, columns } = data;

	return (
		<StyledContent>
			<Section bg="white">
				<Top className="top" color="blue">
					{title}
				</Top>
				<h2>{content.title}</h2>
				<div
					className="md-content"
					dangerouslySetInnerHTML={{
						__html: mdToHtml(content.copy),
					}}
				/>
				{columns.title !== null && (
					<div className="flex">
						<div className="left">
							<Top className="top" color="blue">
								{title}
							</Top>
							<h2>{columns.title}</h2>
							<div
								className="md-content"
								dangerouslySetInnerHTML={{
									__html: mdToHtml(columns.copy),
								}}
							/>
						</div>
						<div className="right">
							<img src={columns.img} alt={title} />
						</div>
					</div>
				)}
			</Section>
		</StyledContent>
	);
};
